export default __webpack_public_path__ + "static/media/t22.min.89ec26a3.png";